import {Component} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {Apollo} from 'apollo-angular';
import {ErrorService} from '../../services/error.service';
import gql from 'graphql-tag';
import {DeleteUser, DeleteUserVariables} from './__generated__/DeleteUser';
import {catchError} from 'rxjs/operators';
import {EMPTY} from 'rxjs';
import {ToastrService} from 'ngx-toastr';

const deleteUserMutation = gql`
    mutation DeleteUser($id: ID) {
      deleteUser(id: $id) {
        error
      }
    }
`;

@Component({
  selector: 'app-user-delete',
  templateUrl: './user-delete.component.html',
  styleUrls: ['./user-delete.component.scss'],
  standalone: false,
})
export class UserDeleteComponent {
  id = '';

  constructor(
    private bsModalRef: BsModalRef,
    private apollo: Apollo,
    private toastr: ToastrService,
    private errService: ErrorService,
  ) {}

  deleteUser(): void {
    this.apollo
      .mutate<DeleteUser, DeleteUserVariables>({
        mutation: deleteUserMutation,
        variables: {
          id: this.id,
        },
        update: cache => cache.evict({id: 'ROOT_QUERY', fieldName: 'users'}),
      })
      .pipe(
        catchError(error => {
          this.errService.handleDefault(error);
          return EMPTY;
        }),
      )
      .subscribe(response => {
        const error = response.data?.deleteUser.error;
        if (error) {
          this.toastr.error($localize`An error has occurred: ${error}.`);
        } else {
          this.toastr.success($localize`User deleted.`);
        }
        this.bsModalRef.hide();
      });
  }

  closeModal(): void {
    this.bsModalRef.hide();
  }
}
